import React from 'react';
import CreateClientForm from '@/components/forms/CreateClientForm';

export const CreateClientPage = () => {
	return <CreateClientForm />;
};
